<div class="swipe-wrapper" [class.disabled]="!enabled()">
  <div #track class="swipe-track" (scroll)="onScroll($event)" tabindex="-1" aria-hidden="false">
    <div class="swipe-content">
      <ng-content />
    </div>

    <div class="swipe-actions" role="group" aria-label="message actions">
      <ng-container *ngTemplateOutlet="actionsTpl?.(); context: actionsContext?.() || {}" />
    </div>
  </div>
</div>
